import { apiDataSource } from './apiDataSource';
import type { DataSource } from './source';

let cached: Promise<DataSource> | null = null;

export function getDataSource(): Promise<DataSource> {
  if (!cached) {
    cached =
      import.meta.env.VITE_DATA_SOURCE === 'mock'
        ? import('../mocks/mockDataSource').then((m) => m.createMockDataSource())
        : Promise.resolve(apiDataSource);
  }
  return cached;
}

export const isMockMode = () => import.meta.env.VITE_DATA_SOURCE === 'mock';
